<template>
  <v-toolbar-title class="v-toolbar-title">
    <div v-if="disabledRedirect" class="toolbar-title">
      <img class="logo-stampyt" :src="src" :alt="alt" />
    </div>
    <router-link v-else :to="path" class="toolbar-title">
      <img class="logo-stampyt" :src="src" :alt="alt" />
    </router-link>
  </v-toolbar-title>
</template>

<script>
export default {
  name: 'LogoLink',
  props: {
    path: {
      type: String,
      default: '/'
    },
    alt: {
      type: String,
      default: 'Logo'
    },
    src: {
      type: String,
      default: ''
    },
    disabledRedirect: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="less" scoped>
.v-toolbar-title {
  height: inherit;
}

.toolbar-title {
  color: inherit;
  text-decoration: inherit;
  height: inherit;
  display: flex;
  align-items: center;
}

.logo-stampyt {
  max-width: 150px;
  max-height: 64px;
  padding: 5px;
}
</style>
